import React, { useEffect } from "react";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  name: string;
  id: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  value?: any;
  errors: any;
  touched: any;
  onChange: any;
  onBlur: any;
}

const CustomInputEmail = ({
  name,
  id,
  label,
  placeholder,
  disabled,
  value,
  errors,
  touched,
  onChange,
  onBlur,
  ...props
}: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // console.log("[CustomInputText] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // console.log("[CustomInputText] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <label htmlFor={name}>{label}</label>

      <input
        type="email"
        name={name}
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        className={`form-control ${touched && errors ? "is-invalid" : ""}`}
        onChange={onChange}
        onBlur={onBlur}
        defaultValue={value}
      />
      {!!errors && touched && <div className="invalid-feedback">{errors}</div>}
    </>
  );
};
export default CustomInputEmail;
